export default "__VITE_ASSET__DUcHI$Qa__"